// store.js
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './indexRedux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const isProd = process.env.NODE_ENV === 'production';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'], // ONLY persist auth
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,

  // 🔒 Disable Redux DevTools in production
  devTools: !isProd && {
    maxAge: 15,     // keep only last 15 actions
    trace: false,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // persist/PURGE carries a non-serializable `result` callback internally
        // (redux-persist's own implementation, not app code) -- logging out
        // anywhere in the app triggered this on every single page load
        // afterward. redux-persist's own docs list PURGE alongside
        // PERSIST/REHYDRATE/REGISTER as expected-non-serializable action types;
        // this repo's ignoredActions list was just missing it. Found by the
        // pass-28 frontend route sweep (every single route failed identically).
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/PURGE', 'persist/REGISTER'],
        ignoredActionPaths: ['payload.expiresAt'],
        ignoredPaths: ['auth.tokenExpiresAt'],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
